import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'info-order-form-provider',
    templateUrl: './templates/info-order-form-provider.component.html',
    styleUrls: ['./styles/info-order-form-provider.component.css']
})
export class InfoOrderFormProviderComponent implements OnInit {
    
    constructor() {}

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/info-order-form-provider.component.ts